import type { Character } from '../domain/character.ts';
import type { PortableCustomContent } from './customDependencies.ts';

/** File extension used for a single exported crawler. */
export const PORTABLE_FILE_EXTENSION = '.dccchar';
export const PORTABLE_FORMAT = 'dcc-character';
export const PORTABLE_SCHEMA_VERSION = 11;

/**
 * The on-disk exchange format. Deliberately small: the character references
 * content by stable ID and never carries copies of official rules text.
 */
export interface PortableCharacterFile {
  format: typeof PORTABLE_FORMAT;
  schemaVersion: number;
  rulesetVersion: string;
  appVersion: string;
  exportedAt: string;
  character: Character;
  /**
   * Player-authored definitions this crawler needs, and NOTHING else.
   *
   * Only content the player wrote is ever carried. Official Skills and
   * Backgrounds are referenced by ID and resolved from the receiving
   * installation's own copy of the book: shipping them would be copying the
   * publisher's content into a file the player passes around.
   *
   * The list is the dependency CLOSURE, not just what the crawler holds. A
   * custom Background brings the custom Skills it offers, and a Skill that only
   * an Undo entry could restore is carried too - otherwise the audit trail
   * arrives unable to reverse itself.
   *
   * At schema 1 this was an unused `unknown[]`. Migration 1 -> 2 replaces it
   * with this shape; those files carried no custom content, so nothing is lost.
   */
  customContent: PortableCustomContent;
}
